var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1475 0.375C16.0558 0.375 10.7359 4.01207 7.77503 7.12387L1.86206 2.73773C1.04076 2.12813 -0.185436 2.77758 0.0244598 3.71125L1.66165 11L0.0237827 18.2894C-0.186113 19.2231 1.04008 19.8719 1.86139 19.2629L7.77435 14.8768C10.7352 17.9879 16.0558 21.625 22.1475 21.625C31.4547 21.625 39.0001 13.125 39.0001 11C39.0001 8.875 31.4547 0.375 22.1475 0.375ZM28.0672 12.5938C27.1701 12.5938 26.4422 11.8799 26.4422 11C26.4422 10.1195 27.1701 9.40625 28.0672 9.40625C28.965 9.40625 29.6922 10.1195 29.6922 11C29.6922 11.8799 28.9644 12.5938 28.0672 12.5938Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishLight);
export default __webpack_public_path__ + "static/media/fish-light.41c5d13c97bedee2a8a7629a391e539d.svg";
export { ForwardRef as ReactComponent };